const checkBackgroundColor = Styles.color.black;

export default checkBackgroundColor;
